import React from 'react';
import './career.css';
// import Avatar from '../Images/csr_1.png'
import Avatar1 from '../Images/csr_2.jpeg'
// import Avatar2 from '../Images/csr_3.png'
import Avatar3 from '../Images/csr_4.jpg'
import Footer from '../Component/NewFooter';




const CSR = () => {
  
  return (
    <>  
    <div className="img_carrierse">
        <img src={Avatar1} alt="img" />
    </div>

    <div className="careers-container">
      <div className="careers-content">
        {/* Title */}
        <div className="title-section">
          <h1 className="careers-title">At Jeyshawn Engineering Limited, we recognize that our responsibility extends beyond delivering quality engineering, procurement, and construction services.

</h1> 
          <div className="orange-underline"></div>
        </div>
        <div className="csr_content">

        <div className="csr_section">  
        {/* Introduction */}
        <p className="intro-text mkbold">
          Our Commitment:
        </p>

        <p className="intro-tex ">At Jeyshawn Engineering Limited, we are committed to making a meaningful and lasting impact in the host communities where we operate, while upholding the highest standards of environmental stewardship, safety, and ethical business practices.</p>

        <p className="intro-tex ">We integrate Corporate Social Responsibility into our core operations by aligning our business objectives with the social, economic, and environmental needs of our stakeholders. Our approach is guided by sustainability, inclusiveness, and long-term value creation.

</p>





        <p className="intro-text">
          We actively support host communities through:
        </p>

        {/* List of Areas */}
        <ul className="catext">
          <li>Local employment and capacity building initiatives.
</li>
          <li>	Educational support programs, including scholarships and school projects.</li>
          <li>Community infrastructure development and social welfare initiatives.
</li>
         

        </ul>
        <p className="intro-text">Our goal is to empower communities and contribute to their sustainable growth.
</p>

</div>

        <div className="img_cover">
            <div className="img_carr">
                <img src={Avatar3} alt="img" />
            </div>
        </div>
        
        </div>


        
      </div>


   
      

    </div>
    <Footer />
    </>
  );
};

export default CSR;